// This file should only contain action type constants.

export const SET_REVIEWS = 'SET_REVIEWS';
export const SET_RATINGS = 'SET_RATINGS';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';



// WEBPACK FOOTER //
// ./src/actions/types.js